import React from "react";

const MaListe = () => {
	return (
		<></>
	)
}

export default MaListe;